function init($el) {
  $(this).on('init', function () {
    if (typeof $el === "undefined") {
      $(this).addClass("-active");
    } else {
      $el.addClass("-active");
    }
  });
}

function pad(d) {
  d = d + 1;
  return (d < 10) ? '0' + d.toString() : d.toString();
}

function addText(currentSlide, countSlider, elNext, elPrev) {
  elNext.text(pad(countSlider - 1));
  elPrev.text(pad(currentSlide));
}

function getCountSlide($sliderItem, $sliderControl) {
  if ($sliderItem.length <= 1) {
    if ($sliderControl) {
      $sliderControl.remove();
    }
    return false
  } else {
    return true
  }
}

function loadSlideImage(e, slide) {
  var $slide = $(e).find('.slider__item').eq(slide != undefined ? slide : 0),
    images = $slide.find('[data-lazyload]');

  Array.prototype.forEach.call(images, function (image) {
    loadImage(image);
  });
}

function loadImage(item) {
  let src = item.getAttribute('data-lazyload');

  if (src == null) return;

  if (item.tagName === "IMG") {
    item.setAttribute("src", src);
  } else if (item.tagName === "SOURCE") {
    item.setAttribute("srcset", src);
  } else {
    item.style.backgroundImage = 'url("' + src + '")';
  }

  item.removeAttribute('data-lazyload');
}

function loadScriptOnce(url, callback) {
  window.scriptLoaded = window.scriptLoaded || {};

  if (window.scriptLoaded[url]) {
    if (window.scriptLoaded[url] === true) {
      if (callback) callback();
    } else {
      window.scriptLoaded[url].then(() => {
        if (callback) callback();
      });
    }
    return;
  }

  const promiseScript = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    script.onload = () => {
      if (/jquery(?:-|\.)/i.test(url)) {
        if (!window.jQuery && window.$) {
          window.jQuery = window.$;
        }
        if (!window.$ && window.jQuery) {
          window.$ = window.jQuery;
        }
      }

      window.scriptLoaded[url] = true;
      if (callback) callback();
      resolve();
    };

    script.onerror = () => {
      delete window.scriptLoaded[url];
      reject(new Error(`Failed to load script: ${url}`));
    };

    document.head.appendChild(script);
  });

  window.scriptLoaded[url] = promiseScript;
}

export {init, addText, getCountSlide, loadSlideImage, loadImage, loadScriptOnce};
